import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { KalturaLogger } from '@kaltura-ng/kaltura-logger';
import { BrowserService } from 'app-shared/kmc-shell/providers/browser.service';
import { Title } from '@angular/platform-browser';
import { AppLocalization } from '@kaltura-ng/mc-shared';
import { ContextualHelpService } from 'app-shared/kmc-shared/contextual-help/contextual-help.service';
import { KmcMainViewBaseService, ViewMetadata } from '../kmc-main-view-base.service';
import { KMCPermissions, KMCPermissionsService } from '../../kmc-permissions';

@Injectable()
export class SettingsAccessControlMainViewService extends KmcMainViewBaseService {
  constructor(
    logger: KalturaLogger,
    browserService: BrowserService,
    router: Router,
    private _appPermissions: KMCPermissionsService,
    appLocalization: AppLocalization,
    titleService: Title,
    contextualHelpService: ContextualHelpService,
  ) {
    super(
      appLocalization,
      logger.subLogger('SettingsAccessControlMainViewService'),
      browserService,
      router,
      titleService,
      contextualHelpService,
    );
  }

  isAvailable(): boolean {
    return this._appPermissions.hasAnyPermissions([
      KMCPermissions.ACCESS_CONTROL_BASE,
      KMCPermissions.ACCESS_CONTROL_ADD,
      KMCPermissions.ACCESS_CONTROL_UPDATE,
      KMCPermissions.ACCESS_CONTROL_DELETE,
    ]);
  }

  getRoutePath(): string {
    return 'settings/accessControl';
  }

  getViewMetadata(): ViewMetadata {
    return {
      viewKey: 'settings-access-control',
      title: this._appLocalization.get('app.titles.settingsAccessControlPageTitle'),
      menu: this._appLocalization.get('app.titles.settingsAccessControlMenuTitle'),
    };
  }
}
